<template>
  <b-container fluid>
    <b-breadcrumb :items="breadcrumbs"/>
    <b-row>
      <b-col class="mb-3" md="4">
        <b-card title="Inbox">
          <p>
            The inbox contains all the currently open events that require your team's attention.
            <router-link to="/events">Click here</router-link> to see all events, including events that are closed, or are currently waiting for a response.
          </p>
        </b-card>
      </b-col>
      <b-col class="mb-3" md="8">
        <b-card no-body>
          <div slot="header">
            {{headerText}}
          </div>
          <b-card-body v-if="events.length == 0">
            <p>No events found.</p>
          </b-card-body>
          <b-list-group flush class="mb-3">
            <b-list-group-item v-for="event in events" :to="eventLink(event)" :key="event.id" class="align-items-start">
              <event-card :event="event"></event-card>
            </b-list-group-item>
          </b-list-group>
          <b-pagination-nav v-if="eventCount" align="center" size="md" :number-of-pages="pageCount" v-model="currentPage" :use-router="true" :limit="10" :link-gen="pageLink"></b-pagination-nav>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import API from '@/lib/api'
import EventCard from '@/components/EventCard'
import TeamPicker from '@/components/TeamPicker'

export default {
  name: 'Inbox',
  components: {
    'event-card': EventCard,
    'team-picker': TeamPicker
  },
  data () {
    return {
      events: [],
      currentPage: parseInt(this.$route.query.page || '1'),
      pageSize: 10,
      eventCount: null
    }
  },
  computed: {
    breadcrumbs () {
      return [
        {text: 'My Vos Voco', to: '/'},
        {text: `${this.team.name} Inbox`, to: `/inbox/${this.teamId}`, active: true}
      ]
    },
    headerText () {
      if (this.eventCount === null) {
        return 'Loading...'
      } else if (this.eventCount === 0) {
        return 'No Events Found'
      } else if (this.eventCount === 1) {
        return '1 Event Found'
      } else {
        return `${this.eventCount} Events Found`
      }
    },
    team () {
      return this.$store.state.user.teams.find((team) => { return team.id === this.teamId })
    },
    teamId () {
      return parseInt(this.$route.params.team_id)
    },
    pageCount () {
      if (this.eventCount != null) {
        return Math.ceil(this.eventCount / this.pageSize)
      } else {
        return null
      }
    }
  },
  created () {
    this.fetchEvents()
  },
  watch: {
    'currentPage' () {
      this.$router.push({path: `/inbox/${this.teamId}`, query: { page: this.currentPage }})
    },
    '$route' (to, from) {
      this.currentPage = parseInt(to.query.page || '1')
      this.fetchEvents()
    },
    team (oldTeam, newTeam) {
      if (oldTeam !== newTeam) {
        this.page = 1
        this.fetchEvents()
      }
    }
  },
  methods: {
    fetchEvents () {
      this.$store.commit('selectCurrentTeam', this.team)
      API.get('events', {context: 'inbox', pageSize: this.pageSize, page: this.currentPage, team_id: this.teamId}, this.$store.getters.authHeaders)
        .then((response) => {
          this.eventCount = response.data.total_count
          this.events = response.data.events
        })
    },
    eventLink (event) {
      return {path: '/events/' + event.id, query: {team_id: this.teamId, context: 'inbox', return_to: this.$route.fullPath}}
    },
    pageLink (page) {
      return {
        path: `/inbox/${this.teamId}`,
        query: { page: page }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Inbox.vue